<template>
  <v-card-text class="pa-4"><slot></slot></v-card-text>
</template>

<script>
export default {}
</script>
